import { render, staticRenderFns } from "./picture-upload-widget.vue?vue&type=template&id=2df7d20e&scoped=true"
import script from "./picture-upload-widget.vue?vue&type=script&lang=js"
export * from "./picture-upload-widget.vue?vue&type=script&lang=js"
import style0 from "./picture-upload-widget.vue?vue&type=style&index=0&id=2df7d20e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df7d20e",
  null
  
)

export default component.exports